import { ComponentType } from '@angular/cdk/overlay';
import { InjectionToken } from '@angular/core';

export const MAINTENANCE_COMPONENT_TYPE: InjectionToken<ComponentType<unknown>>
  = new InjectionToken<ComponentType<unknown>>('Maintenance component constructor');

export interface MaintenancePageModel {
  headline: string;
  description: string;
  actionText: string;
}

export type MaintenanceType = 'error' | 'tooEarly';

export const toEarlyPageContent: MaintenancePageModel = {
  headline: 'Ihr Konto wird gerade eingerichtet.',
  description: 'Sobald die Einrichtung fertiggestellt ist, schließt sich diese Seite automatisch.',
  actionText: 'Bitte warten Sie einen Augenblick.',
};

export const errorPageContent: MaintenancePageModel = {
  headline: 'Es ist ein Fehler aufgetreten.',
  description: '',
  actionText: 'Bitte kontaktieren Sie unseren Kundendienst.',
};
